// src/i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { RPC_MIRROR_PRODUCTCODE } from './utils/constants';
import { getInitialLanguage, supportedLanguages } from './utils/i18nutils';
i18n
    .use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    fallbackLng: 'en', // Default fallback language
    debug: false, // Enable debug mode for development disable for production
    supportedLngs: supportedLanguages, // Restrict to supported languages only
    backend: {
        // If your files are: src/i18n/en/signup.json, src/i18n/es/signup.json
        // loadPath: `${WEBAPP_LOGIN_DOMAIN}/rpc-ui/dist/i18n/{{lng}}/{{ns}}.json`,
        // loadPath: `/rpc-ui/dist/i18n/{{lng}}/{{ns}}.json`,
        loadPath: (productCode === RPC_MIRROR_PRODUCTCODE)
            ? "https://mirror.remotepc.com/rpc-ui/dist/i18n/en/{{ns}}.json"
            : "/rpc-ui/dist/i18n/{{lng}}/{{ns}}.json"
    },
    ns: [],
    lng: (productCode === RPC_MIRROR_PRODUCTCODE) ? "en" : getInitialLanguage(),
    defaultNS: 'common',
    // Added detection and caching configuration for RDP domain. 
    // We want to disable auto detection and caching for RDP domain to always use English.
    detection: {
        // Disable all auto detection for RDP
        order: window.location.hostname.includes('remotedesktop.com')
            ? [] // ← empty = no detection for RDP!
            : ['cookie', 'localStorage', 'navigator'],
        lookupCookie: 'lang',
        lookupLocalStorage: 'i18nextLng',
        // Don't cache detected language for RDP
        caches: window.location.hostname.includes('remotedesktop.com')
            ? [] // ← no caching for RDP!
            : ['localStorage', 'cookie'],
    },
    interpolation: {
        escapeValue: false, // React already prevents XSS by default
    },
    react: {
        useSuspense: false, // Disable Suspense to avoid loading issues
    }
});
// Expose i18n globally for development/testing purposes
if (typeof window !== 'undefined') {
    window.i18n = i18n;
    // Also expose a simple language change function with validation
    window.changeLanguage = function (lng) {
        if (supportedLanguages.indexOf(lng) !== -1) {
            i18n.changeLanguage(lng);
            console.log("Language changed to: ".concat(lng));
        }
        else {
            console.warn("Language '".concat(lng, "' is not supported. Available languages: ").concat(supportedLanguages.join(', ')));
            console.log("Current language remains: ".concat(i18n.language));
        }
    };
}
export default i18n;
